import React, { useState, useMemo } from "react";
import "./cvepage.css";
import Page from "../../Utilities/Page";
import FilterBar from "../../Utilities/FilterBar";
import cveData from "../AboutMe/CVE/data";
import Card from "../../Utilities/Card";
import { withInlineCode } from "../../../Utils/inlineCode";
import { SEVERITIES, severityOf } from "../../../Utils/severity";

/* the repository name inside a GitHub advisory url */
const repoOf = (link = "") => {
  const found = link.match(/github\.com\/[^/]+\/([^/]+)\/security\/advisories\//);

  return found ? found[1] : "";
};

/* the published CVSS score drives the badge; nothing is inferred */
const severityBadges = (item) => {
  const severity = severityOf(item.cvss);

  return (
    <>
      {severity !== "" && <span className={`badge ${severity.toLowerCase()}`}>{`CVSS ${item.cvss} · ${severity}`}</span>}
      {item.showOnHome && <span className="badge accent">featured</span>}
    </>
  )
}

const CVEPage = () => {
  const [search, setSearch] = useState("");
  const [severity, setSeverity] = useState("");
  const [project, setProject] = useState("");

  const projects = useMemo(() => {
    const names = cveData.map((item) => repoOf(item.link)).filter(Boolean);

    return [...new Set(names)].sort((a, b) =>
      a.toLowerCase().localeCompare(b.toLowerCase())
    );
  }, []);

  const filtered = useMemo(() => {
    const keyword = search.toLowerCase();

    return cveData.filter((item) => {
      const matchesSearch =
        keyword === "" ||
        (item.cve || "").toLowerCase().includes(keyword) ||
        (item.details || "").toLowerCase().includes(keyword);
      const matchesSeverity =
        severity === "" || severityOf(item.cvss) === severity;
      const matchesProject = project === "" || repoOf(item.link) === project;

      return matchesSearch && matchesSeverity && matchesProject;
    });
  }, [search, severity, project]);

  const filters = [
    {
      label: "Severity",
      options: SEVERITIES,
      value: severity,
      onChange: setSeverity,
    },
    {
      label: "Project",
      options: projects,
      value: project,
      onChange: setProject,
    },
  ];

  return (
    <Page cls='cve-page fcs' title='CVE | Chai Cheng Xun'>
      <div className="page-wrap">
        <div className="cmd">
          <span className="prompt">$</span> ls ~/research
        </div>
        <div className="d-title">Research and CVEs</div>
        <div className="d-text intro">
          Vulnerabilities I found in open source software, reported to the
          maintainers and fixed before disclosure.
        </div>
        <FilterBar
          placeholder='Search by id or description...'
          search={search}
          setSearch={setSearch}
          filters={filters}
          shown={filtered.length}
          total={cveData.length}
        />
        {filtered.length > 0 ? (
          <div className="card-list">
            {filtered.map((item) => (
              <Card
                key={item.cve}
                to={item.link}
                title={item.cve}
                badges={severityBadges(item)}
                description={withInlineCode(item.details)}
              />
            ))}
          </div>
        ) : (
          <div className="d-text empty">nothing matches that filter</div>
        )}
      </div>
    </Page>
  );
};

export default CVEPage;
